<div id="chart">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [title]="chartOptions.title"
    [stroke]="chartOptions.stroke"
    [plotOptions]="chartOptions.plotOptions">
  </apx-chart>
</div>
